export default {"src":"/_next/static/media/retirement.655fa121.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};